<template>
    <div>

    </div>
</template>

<script>
export default {
  name: 'TermsAndConditions'
}
</script>

<style lang="scss" scoped>

</style>
